import { environment } from '@deltager/organizers/admin/environments/environment';
import { Environment } from '../../shared/models/Environment';

export class AppSettings {
  launchedFromLegacySite: boolean;
  private _baseUrl: string;

  private _envPrefixes = {
    [Environment.Dev]: 'dev.',
    [Environment.Stage]: 'staging.',
    [Environment.Prod]: '',
  };

  set baseUrl(url: string) {
    this._baseUrl = url;
  }

  get rootUrl(): string {
    let url = !this._baseUrl || 0 === this._baseUrl.length ? this.browserBaseUrl : this._baseUrl;

    url = url.includes('localhost:4200') ? `https://${this._envPrefixes[environment.env]}deltager.no` : url;

    return url;
  }

  constructor(
    public affiliateId: number,
    public browserBaseUrl: string,
  ) {}
}
